import { Link } from "react-router-dom";
import { MapPin, Phone, BadgeCheck, Sparkles } from "lucide-react";
import StarRating from "@/components/StarRating";
import SaveButton from "@/components/SaveButton";
import { Badge } from "@/components/ui/badge";

export default function ProviderCard({ p, compact = false }) {
  const typeLabel = p.type === "both" ? "Mobile + Clinic" : p.type === "mobile" ? "Mobile IV" : "IV Clinic";
  return (
    <Link
      to={`/listing/${p.slug}`}
      className="group block bg-white rounded-2xl border border-stone-200/70 overflow-hidden hover:shadow-xl hover:-translate-y-1 hover:border-[#064E3B]/30 transition-all duration-300"
      data-testid={`provider-card-${p.slug}`}
    >
      <div className="relative aspect-[16/10] overflow-hidden bg-stone-100">
        <img
          src={p.hero_image || p.gallery?.[0]}
          alt={p.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        {p.featured && (
          <div className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-[#B4A081] text-white text-[10px] font-semibold uppercase tracking-wider flex items-center gap-1">
            <Sparkles className="w-3 h-3" /> Featured
          </div>
        )}
        <div className="absolute top-3 right-3 flex items-center gap-1.5">
          <SaveButton providerId={p.id} providerSlug={p.slug} />
          <div className="px-2.5 py-1 rounded-full bg-white/95 backdrop-blur text-[#064E3B] text-[10px] font-semibold uppercase tracking-wider">
            {typeLabel}
          </div>
        </div>
      </div>

      <div className="p-5">
        <div className="flex items-start justify-between gap-2 mb-1.5">
          <h3 className="font-display text-lg font-semibold text-stone-900 leading-tight group-hover:text-[#064E3B] transition">
            {p.name}
          </h3>
          {p.verified && <BadgeCheck className="w-5 h-5 text-[#10B981] shrink-0 mt-0.5" />}
        </div>

      <div className="flex items-center gap-2 text-sm text-stone-500 mb-3">
        <MapPin className="w-3.5 h-3.5" />
        <span>{p.city}, {p.state}</span>
        {p.distance_km !== undefined && (
          <span className="ml-auto text-xs font-semibold text-[#10B981] inline-flex items-center gap-1" data-testid="distance-pill">
            {(p.distance_km * 0.621371).toFixed(1)} mi away
          </span>
        )}
      </div>

        <StarRating value={p.avg_rating} count={p.review_count} className="mb-3" />

        {!compact && (
          <div className="flex flex-wrap gap-1.5 mb-4">
            {p.services?.slice(0, 3).map((s) => (
              <Badge key={s.name} variant="secondary" className="bg-stone-100 text-stone-700 hover:bg-stone-100 font-normal text-xs">
                {s.name}
              </Badge>
            ))}
          </div>
        )}

        <div className="flex items-center justify-between border-t border-stone-100 pt-3">
          <div className="flex items-center gap-1.5 text-xs text-stone-500">
            <Phone className="w-3 h-3" />
            <span>{p.phone}</span>
          </div>
          <span className="text-xs font-semibold text-[#064E3B] group-hover:translate-x-0.5 transition-transform">
            View Profile →
          </span>
        </div>
      </div>
    </Link>
  );
}
